export default [
  { icon: 'mdi-pencil', title: 'Ubah Penugasan', event: 'onEdit', akses: 'psp-instruktur-penugasan.update' },
  { icon: 'mdi-delete', title: 'Hapus Penugasan', event: 'onDelete', akses: 'psp-instruktur-penugasan.delete' },
];
